import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const UNIVISION_PROMO_CODE = "2022ViXP1"

export const UnivisionGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(UNIVISION_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({ disabled, handleClick }) => {
    return (
      <>
        <Button
          type="button"
          className="btn"
          primary
          disabled={disabled}
          onClick={() => {
            setSubmissionPromoCode(promoCode)
            handleClick()
          }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
      UNIVISION_PROMO_CODE
    )
  ]

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>
              Enter your T-Mobile or Sprint phone number to begin the redemption process. You will then be prompted to log in to your account.<br /><br />
              If you are a Home Internet only customer, please find your assigned billing phone number on your bill under <a href="https://promotions.t-mobile.com/faq"> "connected devices"</a>.
            </p>
            <p>If you are a T-Mobile for Business customer, please click "<a href={process.env.REACT_APP_TMO_TFB_ID_AUTH_URL} rel="noreferrer">Here</a>".</p>
            <img style={{ marginTop: "1rem" }} src={"images/Univision/Univision_logo.png"} alt="Univision Logo" className="mb-3" />
            <p>
              Get One Year of ViX+ ON US! ViX+ is the new Spanish-language streaming service with more than 10,000 hours of original series, exclusive movie premieres, premium and live sports, plus news and entertainment, live or on-demand.
              <br /><br />
              Already have a ViX+ subscription? Click <a href="https://www.t-mobile.com/tv-streaming/vix-plus-deal">here</a> before you redeem your offer.
            </p>

          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{ marginBottom: "6px" }}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto" />
        </div>
        <div className="mx-auto col-md-4">
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/tv-streaming/vix-plus-deal" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
      </div>
    </section>
  )
}
